import { Rectangle } from '@printu/geom';
export function isHTMLElement(el) {
    if (el && el instanceof HTMLElement) {
        return true;
    }
    return false;
}
export function getAriaLabel(el, fallbackToClass = false) {
    var _a, _b, _c, _d, _e;
    if (isHTMLElement(el)) {
        const result = (_e = (_c = (_a = el.ariaLabel) !== null && _a !== void 0 ? _a : (_b = el.dataset) === null || _b === void 0 ? void 0 : _b.testId) !== null && _c !== void 0 ? _c : (_d = el.dataset) === null || _d === void 0 ? void 0 : _d.testid) !== null && _e !== void 0 ? _e : el.getAttribute('id');
        if (result) {
            return result;
        }
        return fallbackToClass
            ? `${el.tagName.toLowerCase()}.${el.className}`
            : undefined;
    }
    if (el) {
        const elType = typeof el;
        if (elType === 'object') {
            return String(Object(el).constructor);
        }
        return elType;
    }
    return undefined;
}
export function getAriaLabelPath(el, fallbackToClass = false, ignoredLabels = null, root = undefined) {
    var _a;
    const { body } = (_a = el.ownerDocument) !== null && _a !== void 0 ? _a : document;
    const $root = isHTMLElement(root) ? root : body;
    const ignoredLabelsSet = new Set(ignoredLabels !== null && ignoredLabels !== void 0 ? ignoredLabels : []);
    const path = [];
    let $el = el;
    while ($el && $el !== $root && $el !== body) {
        const ariaLabel = getAriaLabel($el, fallbackToClass);
        if (ariaLabel && !ignoredLabelsSet.has(ariaLabel)) {
            path.unshift(ariaLabel);
        }
        $el = $el.parentElement;
    }
    return path.join(' > ');
}
export function getElementFrame(el) {
    if (!el) {
        return Rectangle.EMPTY;
    }
    const clientRect = el.getBoundingClientRect();
    return new Rectangle(clientRect.x || clientRect.left, clientRect.y || clientRect.top, clientRect.width || clientRect.right - clientRect.left, clientRect.height || clientRect.bottom - clientRect.top);
}
export function detachNode(node) {
    const parent = node.parentNode;
    if (parent) {
        try {
            parent.removeChild(node);
        }
        catch (error) {
            /** noop */
        }
    }
}
export function attachNode(parent, node, prepend = false) {
    if (prepend && parent.hasChildNodes()) {
        parent.insertBefore(node, parent.firstChild);
    }
    else {
        parent.appendChild(node);
    }
}
export function isOrContains(container, node) {
    return (container && node && (container === node || container.contains(node)));
}
export const createElement = (document, tagName, attributes, style, children) => {
    const el = document.createElement(tagName);
    if (attributes) {
        Object.keys(attributes).forEach(attr => {
            el.setAttribute(attr, attributes[attr]);
        });
    }
    if (style) {
        Object.keys(style).forEach((name) => {
            el.style[name] = style[name];
        });
    }
    if (children) {
        children.forEach(element => {
            el.appendChild(element);
        });
    }
    return el;
};
export const removeFromParent = (node) => {
    try {
        if (node) {
            node.parentElement.removeChild(node);
        }
    }
    catch (err) {
        // swallow
    }
};
/**
 * The DOM likes values to be fixed to 3 decimal places
 *
 * @public
 */
export function toDomPrecision(value) {
    return value.toFixed(4);
}
/**
 * @public
 */
export function toFixed(value) {
    return value.toFixed(2);
}
export const toPx = (value, toPrecision = toFixed) => toPrecision(value) + 'px';
export const toDomPx = (value) => toPx(value, toDomPrecision);
export function createCanvas(props = {}) {
    var _a, _b, _c;
    props = props || {};
    const canvas = document.createElement('canvas');
    const { body } = document;
    if ((_a = props.append) !== null && _a !== void 0 ? _a : true) {
        attachNode(body, canvas, true);
    }
    canvas.style.position = 'absolute';
    canvas.style.display = 'none';
    canvas.style.visibility = 'hidden';
    canvas.style.display = 'none';
    canvas.width = (_b = props.width) !== null && _b !== void 0 ? _b : 1;
    canvas.height = (_c = props.height) !== null && _c !== void 0 ? _c : 1;
    return canvas;
}
export function disposeCanvas(canvas) {
    if (!canvas) {
        return;
    }
    if (canvas instanceof HTMLElement) {
        removeFromParent(canvas);
    }
    canvas.width = 0;
    canvas.height = 0;
}
